import Link from 'next/link';

import AppLogo from '../AppLogo';
import { getHeaderLink } from '../../../utils/common/category';

import useStyles from './styles';
import { IHeader } from './types';

function Header({ handleToggleMenu, icon: Icon, category }: IHeader) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Icon className={classes.icon} onClick={handleToggleMenu} />
      <Link href={getHeaderLink(category)} passHref>
        <span className={classes.logo}>
          <AppLogo />
        </span>
      </Link>
    </div>
  );
}

export default Header;
